import { jsx as v } from "react/jsx-runtime";
const c = (h) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: /* @__PURE__ */ v(
      "path",
      {
        fill: "currentColor",
        d: "M47.896 18.794v3.233h-8.581c-5.521 0-9.996 4.475-9.996 9.996v8.872c0 1.838-1.503 3.38-3.341 3.35a3.288 3.288 0 0 1-3.228-3.285V16.039h3.077V6.12H6.086v9.918h3.03v24.757c0 9.353 7.518 17.057 16.87 17.083 9.352.026 16.968-7.573 16.968-16.919v-5.3h4.942v2.874h10.018V18.793H47.896Zm-37.815-8.678h11.75v1.927h-11.75v-1.927Zm28.877 25.046v5.656c0 7.131-5.716 13.025-12.848 13.066-7.16.04-12.999-5.772-12.999-12.924V16.039h5.644v24.828c0 4.008 3.2 7.334 7.208 7.373 4.046.039 7.352-3.242 7.352-7.28v-8.938a6 6 0 0 1 6-6h8.581v5.643h-5.442a3.496 3.496 0 0 0-3.496 3.496v.001Zm14.962-.624h-2.027v-11.75h2.027v11.75Z"
      }
    )
  }
);
export {
  c as Plumbing
};
